import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import { v4 as uuid4 } from 'uuid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { VariableResultProfileData, VariableSelectFeatureFlag } from '@makyoapp/makyo-common'
import { User16 } from '@makyoapp/makyo-icon/icon'
import { Button } from '@makyoapp/makyo-ui'

import { useDbClientContext } from '@/context/__project__/DbClientContext'
import { useDbDataV2 } from '@/hooks/useDbDataV2'

import { VariableColumnDd } from './VariableColumnDd'
import { VariableWrapper } from './VariableWrapper'

export default function VariableProfileData({
  id,
  onChange,
  columnTypes,
}: {
  id?: string
  onChange?: (value: VariableResultProfileData) => void
  columnTypes?: ColumnTypes[]
}) {
  const [show, setShow] = useBoolean(false)

  return (
    <VariableWrapper id={id} show={show} setShow={setShow} title={<Trans>Profile Data</Trans>} icon={<User16 />}>
      <VariableProfileDataBody
        setShow={setShow}
        value={{
          id: uuid4(),
          flag: VariableSelectFeatureFlag.ProfileData,
          col: undefined,
        }}
        columnTypes={columnTypes}
        onChange={onChange}
      />
    </VariableWrapper>
  )
}

const DEFAULT_COLUMN_TYPES = Object.values(ColumnTypes).filter(
  (v) => ![ColumnTypes.Connection, ColumnTypes.Lookup].includes(v)
)

export function VariableProfileDataBody({
  onChange,
  setShow,
  value,
  columnTypes = DEFAULT_COLUMN_TYPES,
}: {
  onChange?: (value: VariableResultProfileData) => void
  setShow: (nextShow: boolean) => void
  value: VariableResultProfileData
  columnTypes?: ColumnTypes[]
}) {
  const { dbId } = useDbClientContext()
  const { tables } = useDbClientContext()

  const tblObj = tables.find((tb) => tb.id === window.appUserTableID)

  const { colOptions, col, setCol } = useDbDataV2(columnTypes, [], dbId, tblObj?.id, value?.col)

  return (
    <div className='flex-c flex-col min-w-[200px]'>
      <VariableColumnDd setCol={setCol} col={col} colOptions={colOptions} />
      <div className='w-full px-2'>
        <Button
          className='w-full'
          disabled={!col}
          onClick={() => {
            onChange?.({
              id: value.id,
              flag: VariableSelectFeatureFlag.ProfileData,
              col,
            })
            setShow(false)
          }}
        >
          <Trans>Select</Trans>
        </Button>
      </div>
    </div>
  )
}
